import React from 'react';
import InfoBubble from '@gp/components/InfoBubble';
import type { IBaseProps } from '@home/types/common';
import MobilePlatformIcon from '@gp/assets/svg/platform/mobile.svg';
import PCPlatformIcon from '@gp/assets/svg/platform/pc.svg';
import ConsolePlatformIcon from '@gp/assets/svg/platform/console.svg';
import { isIncludeConsole } from '@gp/utils/common';
import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './PlatformImg.scss';

interface IPlatformImgProps extends IBaseProps {
  // 是否显示气泡
  isBubble?: boolean;
  // 每个平台对应的气泡内容
  bubbles?: {
    mobile: any;
    pc: any;
    console: any;
  };
  platform: 'mobile' | 'pc' | 'console' | 'all platforms' | (string & {});
}

const PlatformIcons = {
  mobile: <SvgIcon type="other-icon" />,
  pc: <SvgIcon type="monitor" />,
  console: <SvgIcon type="game" />,
  // mobile: <img className="dbg-platform-img-item" src={MobilePlatformIcon} alt="" />,
  // pc: <img className="dbg-platform-img-item" src={PCPlatformIcon} alt="" />,
  // console: <img className="dbg-platform-img-item" src={ConsolePlatformIcon} alt="" />,
};

const getPlatformIcon = (platform: 'mobile' | 'pc' | 'console', isBubble?: boolean, bubble?: any) => {
  const platformIcon = PlatformIcons[platform];
  if (!isBubble) return platformIcon;
  return (
    <InfoBubble
      className="globalpedia-modal-font14"
      theme="white"
      DomOrText={platformIcon}
      customBubbleContent={bubble || undefined}
    />
  );
};

const PlatformImg: React.FC<IPlatformImgProps> = (props) => {
  const { isBubble = false, bubbles, platform = '', placeholder } = props;
  // const platformTrim = platform?.trim();
  // const platformLowerCase = platformTrim?.toLowerCase();

  const platformLowerCase =
    (Array.isArray(platform) ? platform.join(',')?.toLowerCase() : platform?.trim()?.toLowerCase()) || '';

  if (!platformLowerCase) return <span>{placeholder}</span>;
  return (
    <div className="dbg-platform-group dbg-platform-img-list">
      {/* mobile */}
      {(platformLowerCase === 'all platforms' || platformLowerCase?.includes('mobile')) &&
        getPlatformIcon('mobile', isBubble, bubbles?.mobile)}
      {/* pc */}
      {(platformLowerCase === 'all platforms' || platformLowerCase?.includes('pc')) &&
        getPlatformIcon('pc', isBubble, bubbles?.pc)}
      {/* console */}
      {(platformLowerCase === 'all platforms' || isIncludeConsole(platformLowerCase)) &&
        getPlatformIcon('console', isBubble, bubbles?.console)}
    </div>
  );
};

export default React.memo(PlatformImg);
